import * as actions from 'actions';

const lowercaseCases = (data) => {
  const newCases = Object.entries(data.cases).reduce((acc, current) => ({
    ...acc,
    [current[0]]: current[1],
  }), {});

  return { ...data, cases: newCases };
};

export default (state = false, action) => {
  switch (action.type) {
    case actions.DATA_FETCHED:

      return lowercaseCases(action.payload);

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/data.js